<template>
  <div class="flex flex-col gap-4">
    <TitreDeux :content="t('createAColor')"/>
    <InputField :placeholder="t('colorName')" v-model="newCouleur"/>

    <div class="flex flex-row justify-end gap-4">
      <BlackClickableText v-if="onCancel" :text="t('cancelAction')" @click="onCancel"/>
      <BlueButton :text="t('validate')" @click="createCouleur"/>
    </div>
  </div>

</template>

<script setup>

import {t} from "@/utils/Traduction";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import InputField from "@/components/molecules/InputField.vue";
import BlackClickableText from "@/components/molecules/BlackClickableText.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {defineProps, ref} from "vue";
import {NotificationStores} from "@/stores/NotificationStores";
import {CouleurStore} from "@/stores/CouleurStore";

const props = defineProps({
  onCancel: {
    type: Function,
    required: false
  },
})

const notificationStore = NotificationStores();
const couleurStore = CouleurStore();

const newCouleur = ref("");

const createCouleur = async () => {
  if(newCouleur.value === "") {
    notificationStore.addNotification(t('colorNameCannotBeEmpty'), "error");
    return;
  }

  xhr.addRequestToQueue("POST", "/couleurs", {libelle: newCouleur.value}, true, true, false,
      (response) => {
        if (response.code !== 201) {
          if (response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t('errorDuringCreateColor'),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStore.addNotification(`${t("color")} ${newCouleur.value} ${t("createSucces")}`, "success");

          couleurStore.couleurs.push(JSON.parse(response.response));

          newCouleur.value = "";

          if(props.onCancel) {
            props.onCancel()
          }
        }
      });
}
</script>

<style scoped>

</style>